import { Link } from 'react-router-dom';
import { forumStats } from '@/mocks/rankings';

export default function BrandIntro() {
  return (
    <section className="py-14 bg-background-50">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
              <i className="ri-star-line"></i>品牌故事
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-5 font-heading">
              关于海角论坛
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed text-sm">
              <p>
                海角论坛创立于2018年，是一个以用户为中心的综合<strong>性交流社区平台</strong>。我们致力于打造一个开放、友好、高质量的在线交流空间，让每个用户都能在这里找到属于自己的归属感。
              </p>
              <p>
                经过八年的发展，海角论坛已经从最初的技术讨论社区，逐步扩展为覆盖<strong>技术交流、生活分享、数码产品、游戏娱乐、职场教育、汽车出行、健康养生、财经投资</strong>八大核心板块的综合性平台。我们始终坚持"内容为王、用户为本"的理念，严格把控内容质量，营造积极健康的社区氛围。
              </p>
              <p>
                海角论坛的核心团队由一群热爱互联网、热爱分享的年轻人组成。我们相信，好的社区不仅仅是信息的集散地，更是人与人之间建立连接的桥梁。在海角论坛，你可以分享知识、交流经验、结识朋友，也可以找到灵感、获得成长。
              </p>
              <p>
                截至目前，海角论坛已累计服务超过<strong>128万注册会员</strong>，产生超过<strong>895万优质帖子</strong>，日均活跃用户超过<strong>3.5万人</strong>。这些数字的背后，是每一位用户对海角论坛的信任与支持。
              </p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <Link
                to="/category/tech-discuss"
                className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                开始探索 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link
                to="/"
                className="px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                返回首页
              </Link>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20online%20community%20team%20collaboration%20abstract%20illustration%20with%20warm%20orange%20and%20teal%20gradients%2C%20diverse%20people%20connecting%20through%20digital%20networks%2C%20clean%20minimal%20style%2C%20professional%20and%20welcoming%20atmosphere&width=800&height=600&seq=about-brand-2026&orientation=landscape"
              alt="海角论坛品牌介绍"
              className="w-full rounded-lg"
            />
            <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-lg p-4 border border-background-200/70">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-user-heart-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-bold text-foreground-950 font-heading">128万+</div>
                  <div className="text-xs text-foreground-500">注册会员</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}